export const createFallbackUpdateNodeData = () => {
  return (nodeId: string, data: any) => {
    console.warn("Fallback updateNodeData called for node:", nodeId, data);
  };
};

export const validateNodeData = (data: any) => {
  if (!data || typeof data !== 'object') {
    return false;
  }
  return true;
};

export const mergeNodeData = (existingData: any, newData: any) => {
  if (!existingData || typeof existingData !== 'object') {
    return newData || {};
  }
  
  if (!newData || typeof newData !== 'object') {
    return existingData;
  }
  
  return {
    ...existingData,
    ...newData
  };
};